import React from "react";
import { TextField, Grid, MenuItem } from "@mui/material";

export const NUMBER_FIELDS = [
    ["price", "Price"],
    ["increase_every", "Increase Every"],
    ["max_results", "Max Results"],
    ["ten_second_limit", "10s Limit"],
    ["minutely_limit", "Minutely Limit"],
    ["hourly_limit", "Hourly Limit"],
    ["daily_limit", "Daily Limit"],
    ["monthly_limit", "Monthly Limit"],
    ["total_limit", "Total Limit"],
];

export const emptyRestriction = () => ({
    endpoint_id: "",
    user_id: "",
    ...Object.fromEntries(NUMBER_FIELDS.map(([field]) => [field, null])),
    disabled: null,
});

export const toPayload = (data) => ({
    endpoint_id: data.endpoint_id,
    user_id: data.user_id,
    ...Object.fromEntries(NUMBER_FIELDS.map(([field]) => [field, data[field]])),
    disabled: data.disabled,
});

const parseNumber = (value) => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
};

const disabledValue =(value) => (value === null || value === undefined ? "inherit" : String(value));
const parseDisabled = (value) => (value === "inherit" ? null : value === "true");

const UserRestrictionFields = ({ data, onChange, saving }) => (
    <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
            <TextField fullWidth required margin="normal" label="Endpoint ID" value={data.endpoint_id || ""} onChange={(e) => onChange("endpoint_id", e.target.value)} disabled={saving} />
        </Grid>
        <Grid item xs={12} md={6}>
            <TextField fullWidth required margin="normal" label="User ID" value={data.user_id || ""} onChange={(e) => onChange("user_id", e.target.value)} disabled={saving} />
        </Grid>
        <Grid item xs={12} md={4}>
            <TextField select fullWidth margin="normal" label="Disabled" value={disabledValue(data.disabled)} onChange={(e) => onChange("disabled", parseDisabled(e.target.value))} disabled={saving} helperText="Inherit = take from plan restriction">
                <MenuItem value="inherit">Inherit</MenuItem>
                <MenuItem value="false">No</MenuItem>
                <MenuItem value="true">Yes</MenuItem>
            </TextField>
        </Grid>
        {NUMBER_FIELDS.map(([field, label]) => (
            <Grid item xs={12} md={4} key={field}>
                <TextField fullWidth margin="normal" label={label} type="number" inputProps={{ min: 0 }}
                    value={data[field] === null || data[field] === undefined ? "" : data[field]}
                    onChange={(e) => onChange(field, parseNumber(e.target.value))}
                    disabled={saving} helperText="Empty = inherit from plan / endpoint" />
            </Grid>
        ))}
    </Grid>
);

export default UserRestrictionFields;
